import React from 'react';

const CheckboxGroupContext = React.createContext();

export { CheckboxGroupContext };
